window.addEventListener('DOMContentLoaded', (event) => {
	const form = document.getElementById('mailing-list-form');

	if (form) {
		form.addEventListener('submit', function (e) {
			e.preventDefault();

			const email = form.elements['email'];
			const nonce = form.elements['newsletter_nonce'];
			const errorEle = document.querySelector(
				'.mailing-list-form__error'
			);

			if (!isEmpty(nonce.value)) {
				if (!isEmpty(email.value) && isEmail(email.value)) {
					const data = new FormData();

					data.append('action', 'subscribe');
					data.append('nonce', nonce.value);
					data.append('email', email.value);

					const xmlhttp = new XMLHttpRequest();
					xmlhttp.onreadystatechange = function () {
						if (xmlhttp.readyState == XMLHttpRequest.DONE) {
							if (xmlhttp.status == 200) {
								const resp = JSON.parse(this.response);

								if (resp.data.status === 'ok') {
									// success state
									if (form) {
										form.classList.add('hidden');
									}
									const success = document.querySelector(
										'.mailing-list-form__success'
									);
									if (success) {
										success.classList.remove('hidden');
									}
								} else {
									// Error state
									const errors = resp.data.errors;

									if (errors.length > 0) {
										errorEle.classList.remove('hidden');
										errorEle.textContent = errors[0];
									}
								}
							}
						}
					};

					errorEle.classList.add('hidden');
					email.classList.remove('error');
					xmlhttp.open('POST', app.ajax_url, true);
					xmlhttp.send(data);
				} else {
					// Error state  invalid email
					email.classList.add('error');
					if (errorEle) {
						errorEle.textContent = app.invalid_email;
						errorEle.classList.remove('hidden');
					}
				}
			}

			return false;
		});
	}
});

function isEmpty(str) {
	return !str.trim().length;
}

function isEmail(email) {
	return String(email)
		.toLowerCase()
		.match(
			/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		);
}
